export const styles = {
  control: {
    label: {
      fontSize: '14px',
      color: '#787878',
    },
  },
}
